/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetSettingsSiteSeparationCloudTags200,
  GetSettingsSiteSeparationCloudTagsParams,
  PostSettingsSiteSeparationCloudTestTags200,
  PostSettingsSiteSeparationCloudTestTagsBody,
  PostSettingsSiteSeparationTestRegexBody,
  PutSettingsSiteSeparationBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Return global site-separation settings used for site per hostname definition
 * @summary Return global site-separation settings
 */
export const getSettingsSiteSeparation = (signal?: AbortSignal) => {
  return apiClient<unknown>({
    url: `/settings/site-separation`,
    method: 'GET',
    signal,
  });
};

export const getGetSettingsSiteSeparationQueryKey = () => {
  return [`/settings/site-separation`] as const;
};

export const getGetSettingsSiteSeparationQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSettingsSiteSeparationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSettingsSiteSeparation>>
  > = ({ signal }) => getSettingsSiteSeparation(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSettingsSiteSeparationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsSiteSeparation>>
>;
export type GetSettingsSiteSeparationQueryError = unknown;

export function useGetSettingsSiteSeparation<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSiteSeparation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettingsSiteSeparation<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSiteSeparation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettingsSiteSeparation<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return global site-separation settings
 */

export function useGetSettingsSiteSeparation<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSettingsSiteSeparationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Rewrites global site-separation settings used for site per hostname definition
 * @summary Rewrite global site-separation settings
 */
export const putSettingsSiteSeparation = (
  putSettingsSiteSeparationBody: PutSettingsSiteSeparationBody,
) => {
  return apiClient<unknown>({
    url: `/settings/site-separation`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putSettingsSiteSeparationBody,
  });
};

export const getPutSettingsSiteSeparationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsSiteSeparation>>,
    TError,
    { data: PutSettingsSiteSeparationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsSiteSeparation>>,
  TError,
  { data: PutSettingsSiteSeparationBody },
  TContext
> => {
  const mutationKey = ['putSettingsSiteSeparation'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsSiteSeparation>>,
    { data: PutSettingsSiteSeparationBody }
  > = (props) => {
    const { data } = props ?? {};

    return putSettingsSiteSeparation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSettingsSiteSeparationMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsSiteSeparation>>
>;
export type PutSettingsSiteSeparationMutationBody =
  PutSettingsSiteSeparationBody;
export type PutSettingsSiteSeparationMutationError = unknown;

/**
 * @summary Rewrite global site-separation settings
 */
export const usePutSettingsSiteSeparation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsSiteSeparation>>,
      TError,
      { data: PutSettingsSiteSeparationBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsSiteSeparation>>,
  TError,
  { data: PutSettingsSiteSeparationBody },
  TContext
> => {
  const mutationOptions = getPutSettingsSiteSeparationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns distinct cloud resource tag names available for cloud resource tag site-separation rules. Names are collected from both the New Cloud Model resource tags and cloud resources still represented as devices. Tags with no usable value are omitted.
 * @summary Return cloud resource tag names
 */
export const getSettingsSiteSeparationCloudTags = (
  params?: GetSettingsSiteSeparationCloudTagsParams,
  signal?: AbortSignal,
) => {
  return apiClient<GetSettingsSiteSeparationCloudTags200>({
    url: `/settings/site-separation/cloud/tags`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetSettingsSiteSeparationCloudTagsQueryKey = (
  params?: GetSettingsSiteSeparationCloudTagsParams,
) => {
  return [
    `/settings/site-separation/cloud/tags`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSettingsSiteSeparationCloudTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
  TError = unknown,
>(
  params?: GetSettingsSiteSeparationCloudTagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSettingsSiteSeparationCloudTagsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>
  > = ({ signal }) => getSettingsSiteSeparationCloudTags(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSettingsSiteSeparationCloudTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>
>;
export type GetSettingsSiteSeparationCloudTagsQueryError = unknown;

export function useGetSettingsSiteSeparationCloudTags<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
  TError = unknown,
>(
  params: undefined | GetSettingsSiteSeparationCloudTagsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettingsSiteSeparationCloudTags<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
  TError = unknown,
>(
  params?: GetSettingsSiteSeparationCloudTagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettingsSiteSeparationCloudTags<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
  TError = unknown,
>(
  params?: GetSettingsSiteSeparationCloudTagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return cloud resource tag names
 */

export function useGetSettingsSiteSeparationCloudTags<
  TData = Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
  TError = unknown,
>(
  params?: GetSettingsSiteSeparationCloudTagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsSiteSeparationCloudTags>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSettingsSiteSeparationCloudTagsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Previews which cloud networks and devices a `cloudResourceTag` site-separation rule would match, without saving the rule. The site name comes from the value of the first selected tag a resource carries, after the chosen transformation.
 * @summary Test a cloud resource tag site-separation rule
 */
export const postSettingsSiteSeparationCloudTestTags = (
  postSettingsSiteSeparationCloudTestTagsBody: PostSettingsSiteSeparationCloudTestTagsBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostSettingsSiteSeparationCloudTestTags200>({
    url: `/settings/site-separation/cloud/test-tags`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSettingsSiteSeparationCloudTestTagsBody,
    signal,
  });
};

export const getPostSettingsSiteSeparationCloudTestTagsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsSiteSeparationCloudTestTags>>,
    TError,
    { data: PostSettingsSiteSeparationCloudTestTagsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsSiteSeparationCloudTestTags>>,
  TError,
  { data: PostSettingsSiteSeparationCloudTestTagsBody },
  TContext
> => {
  const mutationKey = ['postSettingsSiteSeparationCloudTestTags'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsSiteSeparationCloudTestTags>>,
    { data: PostSettingsSiteSeparationCloudTestTagsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postSettingsSiteSeparationCloudTestTags(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettingsSiteSeparationCloudTestTagsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsSiteSeparationCloudTestTags>>
>;
export type PostSettingsSiteSeparationCloudTestTagsMutationBody =
  PostSettingsSiteSeparationCloudTestTagsBody;
export type PostSettingsSiteSeparationCloudTestTagsMutationError = void;

/**
 * @summary Test a cloud resource tag site-separation rule
 */
export const usePostSettingsSiteSeparationCloudTestTags = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsSiteSeparationCloudTestTags>>,
      TError,
      { data: PostSettingsSiteSeparationCloudTestTagsBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsSiteSeparationCloudTestTags>>,
  TError,
  { data: PostSettingsSiteSeparationCloudTestTagsBody },
  TContext
> => {
  const mutationOptions =
    getPostSettingsSiteSeparationCloudTestTagsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Tests configured RegEx for discovered hostname and returns matched hostnames
 * @summary Test configured RegEx for discovered hostname
 */
export const postSettingsSiteSeparationTestRegex = (
  postSettingsSiteSeparationTestRegexBody: PostSettingsSiteSeparationTestRegexBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/settings/site-separation/test-regex`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSettingsSiteSeparationTestRegexBody,
    signal,
  });
};

export const getPostSettingsSiteSeparationTestRegexMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsSiteSeparationTestRegex>>,
    TError,
    { data: PostSettingsSiteSeparationTestRegexBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsSiteSeparationTestRegex>>,
  TError,
  { data: PostSettingsSiteSeparationTestRegexBody },
  TContext
> => {
  const mutationKey = ['postSettingsSiteSeparationTestRegex'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsSiteSeparationTestRegex>>,
    { data: PostSettingsSiteSeparationTestRegexBody }
  > = (props) => {
    const { data } = props ?? {};

    return postSettingsSiteSeparationTestRegex(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettingsSiteSeparationTestRegexMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsSiteSeparationTestRegex>>
>;
export type PostSettingsSiteSeparationTestRegexMutationBody =
  PostSettingsSiteSeparationTestRegexBody;
export type PostSettingsSiteSeparationTestRegexMutationError = unknown;

/**
 * @summary Test configured RegEx for discovered hostname
 */
export const usePostSettingsSiteSeparationTestRegex = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsSiteSeparationTestRegex>>,
      TError,
      { data: PostSettingsSiteSeparationTestRegexBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsSiteSeparationTestRegex>>,
  TError,
  { data: PostSettingsSiteSeparationTestRegexBody },
  TContext
> => {
  const mutationOptions =
    getPostSettingsSiteSeparationTestRegexMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
